<template>
  <div id="challenges" class="under-header padding-bottom">
    <div class="container">
      <div class="panel no-margin">
        <h1>Introduction to GIT</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/tNpZOvCiz9o" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Workshop de Figma</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/63nmF17KgpE" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Implementing APIs</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/ofTA5DZUFpk" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Introduction to React</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/P3BUEmEB1hg" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Setting up Docker-Compose</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/2aFshEkxMfI" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Carrer paths</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/N1-3OEMFSNA" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Workshop VIM</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/V2lrcubwLnY" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Chatbot with DialogFlow</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/ItFxuHQNLT8" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>Machine Learning</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/fybjOXq7Dvo" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
      <div class="panel no-margin">
        <h1>GO</h1>
        <div class="embed-container">
          <iframe src="https://www.youtube.com/embed/mNkqU2X5SIk" frameborder="0" allowfullscreen></iframe>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PastEdition',
};
</script>

<style scoped>
</style>
<style>.embed-container { position: relative; padding-bottom: 56.25%; height: 0; overflow: hidden; max-width: 100%; } .embed-container iframe, .embed-container object, .embed-container embed { position: absolute; top: 0; left: 0; width: 100%; height: 100%; }</style>
